import React, { useState } from "react";
import TemplateMessForm from "./TemplateMessForm";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import ModalBox from "../../ui/ModalBox";

const TemplateMessAdd = () => {
  //state which check open or close modal
  const [open, setOpen] = useState(false);
  //var to navigate another page

  const navigate = useNavigate();
  // close modal function

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  //open modal function

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New Template
      </Typography>
      <TemplateMessForm handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Template"
        name="Template Message"
      />
    </>
  );
};

export default TemplateMessAdd;
